import { useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { callAPI, s3CacheKey } from 'helpers';

// Lazily loads the round-1 course list (courses_round1.json) into redux the
// first time a folio component needs it. The student app's Profile container
// stopped fetching it eagerly (off-season bandwidth), so folio cards and the
// Builder pull it on demand instead — whichever renders first triggers the
// single fetch; everyone shares the same store entry.
let fetching = false;
// โหลดล้ม (S3 สะดุด/ad-blocker/wifi captive) → เดิม effect ไม่รันซ้ำ (deps ไม่เปลี่ยน) การ์ดค้าง "กำลังโหลด…" ตลอด
// → เก็บสถานะล้มไว้ + retry เอง 1 ครั้งหลัง 3 วิ + ให้ component สั่ง retry ได้
let failedAt = 0;
const listeners = new Set();
const notify = () => listeners.forEach(fn => fn(failedAt));

const useCoursesR1 = () => {
  const dispatch = useDispatch();
  const coursesR1 = useSelector(state => _.get(state, 'app.coursesR1'));
  const courseMapR1 = useSelector(state => _.get(state, 'app.courseMapR1'));
  const [loadFailed, setLoadFailed] = useState(Boolean(failedAt));
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const fn = (f) => setLoadFailed(Boolean(f));
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(coursesR1) || fetching) return undefined;
    fetching = true;
    let retryTimer = null;
    let alive = true;
    const fetchCourses = async () => {
      try {
        const courses = await callAPI({
          fullURL: `https://my-tcas.s3.ap-southeast-1.amazonaws.com/mytcas/courses_round1.json?timestamp=${s3CacheKey()}`,
        });
        failedAt = 0;
        dispatch({ type: 'UPDATE_COURSES_R1', courses });
        notify();
      } catch (error) {
        console.error(new Error(`Error while trying to fetch round-1 courses: ${error.message}`));
        const first = !failedAt;
        failedAt = Date.now();
        notify();
        if (first && alive) retryTimer = setTimeout(() => setAttempt(a => a + 1), 3000);   // retry อัตโนมัติครั้งเดียว (ไม่ตั้งถ้า unmount แล้ว)
      } finally {
        fetching = false;
      }
    };
    fetchCourses();
    return () => { alive = false; if (retryTimer) clearTimeout(retryTimer); };
  }, [coursesR1, dispatch, attempt]);

  const retry = useCallback(() => { if (!fetching) setAttempt(a => a + 1); }, []);
  return { coursesR1: coursesR1 || [], courseMapR1: courseMapR1 || {}, loadFailed, retry };
};

export default useCoursesR1;
